import React from 'react';
import { useTheme } from '@/hooks/useTheme';

export function MatchSkeleton() {
  const colors = useTheme();

  return (
    <div
      className="animate-pulse"
      style={{
        borderRadius: 16,
        padding: 16,
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.surface,
        marginBottom: 12,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 56, height: 56, borderRadius: 28, backgroundColor: colors.background }} />
          <div style={{ width: 64, height: 12, borderRadius: 6, backgroundColor: colors.background }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 16px' }}>
          <div style={{ width: 48, height: 24, borderRadius: 8, backgroundColor: colors.background }} />
          <div style={{ width: 64, height: 8, borderRadius: 4, backgroundColor: colors.background, marginTop: 4 }} />
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 56, height: 56, borderRadius: 28, backgroundColor: colors.background }} />
          <div style={{ width: 64, height: 12, borderRadius: 6, backgroundColor: colors.background }} />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 12, borderTop: `1px solid ${colors.border}` }}>
        <div style={{ width: 128, height: 12, borderRadius: 6, backgroundColor: colors.background }} />
        <div style={{ width: 64, height: 24, borderRadius: 12, backgroundColor: colors.background }} />
      </div>
    </div>
  );
}
